import { z } from 'zod';

const LOCAL_STORAGE_KEY = 'bulkOfferingFlow_lastUsedFrequency';
const DEFAULT_BILLING_FREQUENCY = '12';

// Standard billing frequency values (Monthly, Quarterly, Semi-Annually, Annually)
const STANDARD_FREQUENCIES = new Set(['1', '3', '6', '12']);

// Module-level cache - initialized once on module load
let currentDefaultFrequency = getLastUsedBillingFrequency();

function getLastUsedBillingFrequency(): string {
  try {
    const value = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!value) {
      return DEFAULT_BILLING_FREQUENCY;
    }

    // Validate that the value is a number-like string
    const parsed = z
      .string()
      .regex(/^\d+$/)
      .default(DEFAULT_BILLING_FREQUENCY)
      .parse(value);

    // Only return if it's a standard frequency, otherwise use default
    return STANDARD_FREQUENCIES.has(parsed)
      ? parsed
      : DEFAULT_BILLING_FREQUENCY;
  } catch {
    return DEFAULT_BILLING_FREQUENCY;
  }
}

function setLastUsedBillingFrequency(value: string): void {
  // Only cache standard billing frequencies, not custom values
  if (value && STANDARD_FREQUENCIES.has(value)) {
    localStorage.setItem(LOCAL_STORAGE_KEY, value);
    currentDefaultFrequency = value;
  }
}

export function getCachedBillingFrequency(): string {
  return currentDefaultFrequency;
}

export function cacheBillingFrequency(value: string): void {
  setLastUsedBillingFrequency(value);
}

export function clearCachedBillingFrequency(): void {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
  currentDefaultFrequency = DEFAULT_BILLING_FREQUENCY;
}
